import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Skeleton,
  TableHead,
  TableHeader,
} from "@pushpress/pushpress-ui";

export default function TableSkeleton({
  numCols,
  numRows,
}: {
  numCols: number;
  numRows: number;
}) {
  return (
    <Table className="tw-divide-y tw-divide-neutral-300 tw-bg-white">
      <TableHeader>
        <TableRow>
          {Array.from({ length: numCols }).map((_, idx) => (
            <TableHead key={idx} className="tw-bg-neutral-50">
              <Skeleton className="tw-h-4 tw-w-24" />
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody className="tw-divide-y tw-divide-neutral-200">
        {Array.from({ length: numRows }).map((_, rowIdx) => (
          <TableRow key={rowIdx} className="tw-h-12">
            {Array.from({ length: numCols }).map((_, colIdx) => (
              <TableCell key={colIdx}>
                <Skeleton className="tw-h-4 tw-w-full" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
